module.exports = __webpack_public_path__ + "static/media/all_men_600.9893872d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newSite/ImagePreview/img/all_men_600.jpg
// module id = 1408
// module chunks = 0